// Video player with customized video preview
const playBtn = document.getElementsByClassName('video-embed__play');
if (playBtn.length > 0) {
    var iframes = [];
    // create youtube api tag
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    
    // foreach custom play button
    for (var i = 0; i < playBtn.length; i++) {
        // find its associated iframe and add enablejsapi param
        var thisPlayBtn = playBtn.item(i);
        var iframe = thisPlayBtn.nextElementSibling;
        iframe.src = iframe.src.replace('?feature=oembed','?feature=oembed&enablejsapi=1');
        // set id, push id to iframes array
        var videoId = 'yt-video-' + i;
        iframe.setAttribute('id', videoId);
        iframes.push(videoId);
    }

    // foreach iframe, add a new yt player
    function onYouTubeIframeAPIReady() {
        for (var i = 0; i < iframes.length; i++) {
           var videoId = iframes[i];
           var player = 'player-' + i;
           window[player] = new YT.Player(videoId, {
                events: {
                    'onReady': onPlayerReady(videoId, player),
                }
            });
        }
    }

    // when player is ready, hook click listener to its play button
    function onPlayerReady(videoId, player) {
        var thisIframe = document.getElementById(videoId);
        var thisPlayBtn = thisIframe.previousElementSibling;
        var previewImage = thisPlayBtn.previousElementSibling;
        // on play button click, hide preview and play video
        thisPlayBtn.addEventListener('click', function() {
            thisPlayBtn.style.display = 'none';
            previewImage.style.display = 'none';
            thisIframe.style.display = 'block';
            window[player].playVideo();
        });
    }
}